import { User, UserManager } from "oidc-client";

let userManager: UserManager | undefined;

async function getUserManager() {
  if (!userManager) {
    const redirectUri = `${window.STUDENT_ENV?.REACT_APP_IMLP_REDIRECT_URI}`;

    const settings = {
      authority: window.STUDENT_ENV?.REACT_APP_IMLP_AUTHORITY,
      client_id: window.STUDENT_ENV?.REACT_APP_IMLP_CLIENT_ID,
      redirect_uri: redirectUri,
      silent_redirect_uri: redirectUri,
      response_type: "code",
      scope: window.STUDENT_ENV?.REACT_APP_IMLP_SCOPE,
      revokeAccessTokenOnSignout: true,
      staleStateAge: 43200,
      extraQueryParams: {
        login_hint: JSON.stringify({
          siteId: "0",
          tenant: window.STUDENT_ENV?.REACT_APP_IMLP_TENANT ?? "Tenant.Universal",
          clientId: window.STUDENT_ENV?.REACT_APP_IMLP_CLIENT_ID
        })
      }
    };

    userManager = new UserManager(settings);
    try {
      await userManager.clearStaleState();
    } catch (e) {
      // ignore error
    }
  }

  return userManager;
}

export function login(): Promise<void> {
  return getUserManager().then((userManager) => userManager.signinRedirect());
}

export function getUser(): Promise<User | null> {
  return getUserManager().then((userManager) => userManager.getUser());
}

export function signinCallback(): Promise<User> {
  return getUserManager().then((userManager) => userManager.signinRedirectCallback());
}

export function resetUserManager() {
  userManager = undefined;
}

// TODO: add logic to check if the token needs to be renewed and renew it automatically
// export function renewToken(): Promise<User> {
//   return getUserManager().then((userManager) => {
//     return userManager.signinSilent();
//   });
// }

export function logout(): Promise<void> {
  return getUserManager().then((userManager) => {
    sessionStorage.clear();
    return userManager.signoutRedirect();
  });
}

export async function oneTimeTokenLogin(token: string) {
  // NOTE: this scope is not granted to our client ID, but it is granted to the Gateway client ID.
  // It is required to get a JWT token that can later be turned into a OTT. Thus, we must append it
  // to the scopes we send to the gateway API when we redeem the one-time token.
  const requiredOttScope = "Scope.IMLP.Default";

  const baseUri = window.STUDENT_ENV?.REACT_APP_MPNG_API_BASE_URL;
  let scopes = window.STUDENT_ENV?.REACT_APP_IMLP_SCOPE;

  if (!scopes.includes(requiredOttScope)) {
    scopes = `${scopes} ${requiredOttScope}`;
  }

  const url = `${baseUri}Security/OneTimeToken/Redeem?requiredScopes=${scopes}`;

  const result = await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`
    }
  });

  if (!result.ok) {
    console.error("Error fetching access token and refresh token:", {
      status: result.status,
      message: result.statusText
    });
    throw new Error("Failed to fetch access token and refresh token");
  }

  const data = await result.json();
  return {
    accessToken: data.accessToken,
    refreshToken: data.refreshToken
  };
}

export async function createOneTimeToken() {
  const baseUri = window.STUDENT_ENV?.REACT_APP_IMLP_AUTHORITY;
  const url = `${baseUri}/v3/transfer/initiate`;
  const token = sessionStorage.getItem("imlpToken");

  const result = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  if (!result.ok) {
    console.error("Error creating one-time token:", {
      status: result.status,
      message: result.statusText
    });
    return null;
  }

  const data = await result.json();
  return data.code;
}
